export default __webpack_public_path__ + "static/media/visity_main.26fc0bec.PNG";